import { useUnit } from 'effector-react';

import { enterpriseStore } from 'apps/portal/state/enterprise';

export function useSelectedEnterpriseId() {
  const { selectedEnterpriseId } = useUnit(enterpriseStore);

  return selectedEnterpriseId;
}
